import { saasHostLoginReturnTo } from '@/platform/saas/saasHostUi';

export const LOGIN_RETURN_TO_KEY = 'loginReturnTo';

/** Path+search for post-login return. Keeps /saas/start/?slug= so create can open {slug}.communiosocial.com. */
export function currentPathReturnTo(pathname = '', search = ''): string {
  const p = `${pathname}${search}`;
  return p.startsWith('/') ? p : '/';
}

/** Apex host Sign in returns here so members can pick a community (not marketing /). */
export function defaultLoginReturnTo(env?: Record<string, string | undefined>): string {
  return saasHostLoginReturnTo(env);
}

export function persistLoginReturnTo(returnTo: string) {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(LOGIN_RETURN_TO_KEY, returnTo.startsWith('/') ? returnTo : '/');
}

export function consumeLoginReturnTo(fallback = '/'): string {
  if (typeof window === 'undefined') {
    return fallback.startsWith('/') && fallback !== '' ? fallback : '/';
  }
  const stored = sessionStorage.getItem(LOGIN_RETURN_TO_KEY);
  sessionStorage.removeItem(LOGIN_RETURN_TO_KEY);
  if (stored?.startsWith('/') && stored !== '') return stored;
  return fallback.startsWith('/') && fallback !== '' ? fallback : '/';
}
